import { render, staticRenderFns } from "./tabMBLUICustom.vue?vue&type=template&id=1bd88e0d&scoped=true&"
import script from "./tabMBLUICustom.vue?vue&type=script&lang=js&"
export * from "./tabMBLUICustom.vue?vue&type=script&lang=js&"
import style0 from "./tabMBLUICustom.vue?vue&type=style&index=0&id=1bd88e0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd88e0d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bd88e0d')) {
      api.createRecord('1bd88e0d', component.options)
    } else {
      api.reload('1bd88e0d', component.options)
    }
    module.hot.accept("./tabMBLUICustom.vue?vue&type=template&id=1bd88e0d&scoped=true&", function () {
      api.rerender('1bd88e0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/tabs/tabMBLUICustom.vue"
export default component.exports